export default "__VITE_ASSET__6sXDCb4b__";